module.exports = __webpack_public_path__ + "static/media/IMG_5049.22ae79ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/IMG_5049.jpg
// module id = 489
// module chunks = 0